export enum FrequencyTypeCode {
  EVENTUAL = "0",
  DAYS_SPECIAL = "1",
}
